import { positive } from "is_js";

const sizes = ["Junior", "Youth", "Small", "Medium", "Large", "Extra Large"];
const batSizes = [
  "Long Handle",
  "Short Handle",
  "Harrow",
  "6",
  "5",
  "4",
  "3",
  "2",
  "1",
];
const batWeights = [
  "2 lbs 5 oz",
  "2 lbs 6 oz",
  "2 lbs 7 oz",
  "2 lbs 8 oz",
  "2 lbs 9 oz",
  "2 lbs 10 oz",
  "2 lbs 11 oz",
  "2 lbs 12 oz",
  "2 lbs 13 oz",
  "2 lbs 14 oz",
  "2 lbs 15 oz",
  "3 lbs 0 oz",
  "3 lbs 1 oz",
  "3 lbs 2 oz",
  "3 lbs 3 oz",
  "3 lbs 4 oz",
  "3 lbs 5 oz",
  "3 lbs 6 oz",
  "One Weight"
];

const batHandles = ["Round", "Oval", "Semi-Oval"];

const accessoriesSizes = [
  "Junior",
  "Youth",
  "Small Adult",
  "Medium Adult",
  "Large Adult",
  "One size",
];

const colours = [
  "Navy",
  "Maroon",
  "Green",
  "Black",
  "White",
  "Gold",
  "Red",
  "Sky Blue",
];


export const bespokeBatOptions = [
    {
      id: 1,
      heading: "Size",
      fieldValues: batSizes.map((val) => ({value : val, label: val})),
    },
    {
      id: 2,
      heading: "Weight",
      fieldValues: batWeights.map((val) => ({value : val, label: val})),

    },
    {
      id: 3,
      heading: "Handle",
      fieldValues: batHandles.map((val) => ({value : val, label: val})),
    }
];

export const optionsByCategory = {
  "Workshop Cricket Bats": [{
      name: "Size",
      position: 0,
      values: batSizes,
    },
    {
      name: "Weight",
      position: 1,
      values: batWeights,
    },
  ],
  "Bespoke Cricket Bats": [
    {
      name: "Size",
      position: 0,
      values: batSizes,
    },
    {
      name: "Weight",
      position: 1,
      values: batWeights,
    },
    {
     name: "Handle",
      position: 2,
      values: batHandles
    }
  ],
  "Batting Gloves": [
    {
      name: "Hand",
      position: 0,
      values: ["Right", "Left"],
    },
    {
      name: "Size",
      position: 1,
      values: [
        "Junior",
        "Youth",
        "Small Adult",
        "Medium Adult",
        "Large Adult",
        "Extra Large Adult",
      ],
    },
  ],
  "Batting Pads": [
    {
      name: "Hand",
      position: 0,
      values: ["Right", "Left"],
    },
    {
      name: "Size",
      position: 1,
      values: [
        "Junior",
        "Youth",
        "Small Adult",
        "Medium Adult",
        "Large Adult",
        "Extra Large Adult",
      ],
    },
  ],
  "Wicket Keeping Gloves": [
    {
      name: "Size",
      position: 0,
      values: sizes,
    },
  ],
  "Wicket Keeping Pads": [
    {
      name: "Size",
      position: 0,
      values: sizes,
    },
  ],
  Helmets: [
    {
      name: "Colour",
      position: 0,
      values: colours,
    },
    {
      name: "Size",
      position: 1,
      values: sizes,
    },
  ],
  Bags: [
    {
      name: "Colour",
      position: 0,
      values: colours,
    },
    {
      name: "Style",
      position: 1,
      values: ["Duffle", "Holdall", "Wheelie Holdall"],
    },
  ],
  Shoes: [
    {
      name: "Size",
      position: 0,
      values: [
        "3",
        "3.5",
        "4",
        "4.5",
        "5",
        "5.5",
        "6",
        "6.5",
        "7",
        "7.5",
        "8",
        "8.5",
        "9",
        "9.5",
        "10",
        "10.5",
        "11",
        "11.5",
        "12",
        "12.5",
        "13",
        "13.5",
        "14",
      ],
    },
  ],
  Accessories: [
    {
      name: "Size",
      postion: 0,
      values: accessoriesSizes,
    },
    {
      name: "Colour",
      position: 1,
      values: colours,
    },
  ],
  Clothing: [
    {
      name: "Size",
      position: 0,
      values: [
        "Extra Small (XS)",
        "Small (S)",
        "Medium (M)",
        "Large (L)",
        "Extra Large (XL)",
        "XXL (2XL)",
        "XXXL (3XL)",
        "XXXXL (4XL)",
        "8",
        "10",
        "12",
        "14",
        "16",
        "18",
        "X Small (26)",
        "X Small/Small (28)",
        "Small (30)",
        "Small/Medium(32)",
        "Medium (34)",
        "Medium/Large(36)",
        "Large (38)",
        "Large/X Large(40)",
        "X Large (42)",
        "XL/2X Large (44)",
        "2X Large (46)",
      ],
    },
    {
      name: "Colour",
      position: 1,
      values: [
        "Black",
        "White",
        "Gray",
        "Navy blue",
        "Red",
        "Pink",
        "Blue",
        "Green",
        "Brown",
        "Beige",
        "Olive",
        "Burgundy",
        "Purple",
        "Teal",
        "Yellow",
        "Orange",
        "Cream",
        "Charcoal",
        "Maroon",
        "Denim (blue)",
      ],
    },
  ],
  Services:[
    {
      name:"Type",
      position:0,
      values:["Service"]
    }
  ],
  Memorabilias:[
    {
      name:"Type",
      position:0,
      values:["Memorabilia"]
    }
  ]
};

const memorabiliaVariant = [{option1:"Memorabilia", id:"Memorabilia"}]
const servicesVariant = [{option1:"Service", id:"Service"}];

const shoesVariants = optionsByCategory["Shoes"][0].values.map((val) => ({
  option1: val,
  id: val,
}));

const wicketKeepingGlovesVariants = optionsByCategory[
  "Wicket Keeping Gloves"
][0].values.map((val) => ({
  option1: val,
  id: val,
}));

const wicketKeepingPadsVariants = optionsByCategory[
  "Wicket Keeping Pads"
][0].values.map((val) => ({
  option1: val,
  id: val,
}));

const [helmetColourOption, helmetSizeOption] = optionsByCategory["Helmets"];
const helmetsVariants = helmetColourOption.values
  .map((colorValue) => {
    return helmetSizeOption.values.map((sizeValue) => ({
      option1: colorValue,
      option2: sizeValue,
      id: `${colorValue}-${sizeValue}`,
    }));
  })
  .flat();

const [clothingSizeOption, clothingColourOption] =
  optionsByCategory["Clothing"];
const clothingVariants = clothingSizeOption.values
  .map((colorValue) => {
    return clothingColourOption.values.map((sizeValue) => ({
      option1: colorValue,
      option2: sizeValue,
      id: `${colorValue}-${sizeValue}`,
    }));
  })
  .flat();

const [bagColourOption, bagStyleOption] = optionsByCategory["Bags"];
const bagVariants = bagColourOption.values
  .map((colorValue) => {
    return bagStyleOption.values.map((sizeValue) => ({
      option1: colorValue,
      option2: sizeValue,
      id: `${colorValue}-${sizeValue}`,
    }));
  })
  .flat();

const [battingGlovesColourOption, battingGlovesSizeOption] =
  optionsByCategory["Batting Gloves"];
const battingGlovesVariants = battingGlovesColourOption.values
  .map((colorValue) => {
    return battingGlovesSizeOption.values.map((sizeValue) => ({
      option1: colorValue,
      option2: sizeValue,
      id: `${colorValue}-${sizeValue}`,
    }));
  })
  .flat();

const [battingPadsColourOption, battingPadsSizeOption] =
  optionsByCategory["Batting Gloves"];
const battingPadsVariants = battingPadsColourOption.values
  .map((colorValue) => {
    return battingPadsSizeOption.values.map((sizeValue) => ({
      option1: colorValue,
      option2: sizeValue,
      id: `${colorValue}-${sizeValue}`,
    }));
  })
  .flat();

const [accessoriesSizeOption, accessoriesColourOption] =
  optionsByCategory["Accessories"];
const accessoriesVariants = accessoriesSizeOption.values
  .map((sizeValue) => {
    return accessoriesColourOption.values.map((colorValue) => ({
      option1: colorValue,
      option2: sizeValue,
      id: `${colorValue}-${sizeValue}`,
    }));
  })
  .flat();

const batVariants = [{option1: "Long Handle", option2: "2 lbs 5 oz", id: `junior-long-handle-54`}, 
                     {option1: "Long Handle", option2: "2 lbs 6 oz", id: `junior-long-handle-61`}, 
                     {option1: "Long Handle", option2: "2 lbs 7 oz", id: `junior-long-handle-71`}, 
                     {option1: "Long Handle", option2: "2 lbs 8 oz", id: `junior-long-handle-88`},
                     {option1: "Long Handle", option2: "2 lbs 9 oz", id: `junior-long-handle-99`},
                     {option1: "Long Handle", option2: "2 lbs 10 oz", id: `junior-long-handle-10`},
                     {option1: "Long Handle", option2: "2 lbs 11 oz", id: `junior-long-handle-11`},
                     {option1: "Long Handle", option2: "2 lbs 12 oz", id: `junior-long-handle-12`},
                     {option1: "Long Handle", option2: "2 lbs 13 oz", id: `junior-long-handle-13`},
                     {option1: "Long Handle", option2: "2 lbs 14 oz", id: `junior-long-handle-14`},
                     {option1: "Long Handle", option2: "2 lbs 15 oz", id: `junior-long-handle-15`},
                     {option1: "Long Handle", option2: "3 lbs 0 oz", id: `junior-long-handle-0`},
                     {option1: "Long Handle", option2: "3 lbs 1 oz", id: `junior-long-handle-1`},
                     {option1: "Long Handle", option2: "3 lbs 2 oz", id: `junior-long-handle-2`},
                     {option1: "Long Handle", option2: "3 lbs 3 oz", id: `junior-long-handle-3`},
                     {option1: "Long Handle", option2: "3 lbs 4 oz", id: `junior-long-handle-4`},
                     {option1: "Long Handle", option2: "3 lbs 5 oz", id: `junior-long-handle-5`},
                     {option1: "Long Handle", option2: "3 lbs 6 oz", id: `junior-long-handle-6`},
                     {option1: "Short Handle", option2: "2 lbs 5 oz", id: `junior-short-handle-55`}, 
                     {option1: "Short Handle", option2: "2 lbs 6 oz", id: `junior-short-handle-66`}, 
                     {option1: "Short Handle", option2: "2 lbs 7 oz", id: `junior-short-handle-7`}, 
                     {option1: "Short Handle", option2: "2 lbs 8 oz", id: `junior-short-handle-8`},
                     {option1: "Short Handle", option2: "2 lbs 9 oz", id: `junior-short-handle-9`},
                     {option1: "Short Handle", option2: "2 lbs 10 oz", id: `junior-short-handle-10`},
                     {option1: "Short Handle", option2: "2 lbs 11 oz", id: `junior-short-handle-11`},
                     {option1: "Short Handle", option2: "2 lbs 12 oz", id: `junior-short-handle-12`},
                     {option1: "Short Handle", option2: "2 lbs 13 oz", id: `junior-short-handle-13`},
                     {option1: "Short Handle", option2: "2 lbs 14 oz", id: `junior-short-handle-14`},
                     {option1: "Short Handle", option2: "2 lbs 15 oz", id: `junior-short-handle-15`},
                     {option1: "Short Handle", option2: "3 lbs 0 oz", id: `junior-short-handle-0`},
                     {option1: "Short Handle", option2: "3 lbs 1 oz", id: `junior-short-handle-1`},
                     {option1: "Short Handle", option2: "3 lbs 2 oz", id: `junior-short-handle-2`},
                     {option1: "Short Handle", option2: "3 lbs 3 oz", id: `junior-short-handle-3`},
                     {option1: "Short Handle", option2: "3 lbs 4 oz", id: `junior-short-handle-4`},
                     {option1: "Short Handle", option2: "3 lbs 5 oz", id: `junior-short-handle-5`},
                     {option1: "Short Handle", option2: "3 lbs 6 oz", id: `junior-short-handle-6`},
                     {option1: "Harrow", option2: "One Weight", id: `junior-harrow-one-weight`},
                     {option1: "6", option2: "One Weight", id: `junior-6-one-weight`},
                     {option1: "5", option2: "One Weight", id: `junior-5-one-weight`},
                     {option1: "4", option2: "One Weight", id: `junior-4-one-weight`},
                     {option1: "3", option2: "One Weight", id: `junior-3-one-weight`},
                     {option1: "2", option2: "One Weight", id: `junior-2-one-weight`},
                     {option1: "1", option2: "One Weight", id: `junior-1-one-weight`}];

export const variantsByCategory = {
  "Workshop Cricket Bats": batVariants,
  "Bespoke Cricket Bats": [],
  "Batting Gloves": battingGlovesVariants,
  "Batting Pads": battingPadsVariants,
  "Wicket Keeping Gloves": wicketKeepingGlovesVariants,
  "Wicket Keeping Pads": wicketKeepingPadsVariants,
  Helmets: helmetsVariants,
  Bags: bagVariants,
  Shoes: shoesVariants,
  Accessories: accessoriesVariants,
  Clothing: clothingVariants,
  Services: servicesVariant,
  Memorabilias:memorabiliaVariant
};
